// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"47899":"fc0915f1ce14793f","55117":"365cadcf90412c80","65607":"7eae5f1fa35395a5"}[chunkId] + ".css";
};